<template>
  <div class="notification-details">
    <div class="notification-details-header">
      <div class="ndh-info">
        <p v-if="notification.creationtime" class="ndh-info-date">{{ notification.creationtime }}</p>
      </div>
      <button @click="deleteNotificaiton(notification.id)">
        <img src="/assets/images/trash-can.svg" alt="delete message">
      </button>
    </div>
    <div class="notification-details-content" v-bar="{preventParentScroll: true, scrollThrottle: 15, scrollingPhantomDelay: 200}">
      <div>
        <p v-if="notification.title" class="ndc-title">{{ notification.title }}</p>
        <img v-if="notification.image" :src="notification.image.url" alt="img">
        <p v-if="notification.description" v-html="parseMessage(notification.description)" class="ndc-text"></p>
      </div>
    </div>
    <div class="notification-details-footer">
      <base-button @click="closeDetails" variant="text">{{ $t('common.close') }}</base-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notification-details',
  props: {
    notification: {
      type: Object
    }
  },
  methods: {
    closeDetails () {
      this.$emit('close-details')
    },
    deleteNotificaiton (message) {
      this.$emit('delete-notification', [message])
    },
    parseMessage (text) {
      const linkRegex = /((http:\/\/|https:\/\/)[\w?=&/-;#~%-]+[\w?=&/-;.#~%-]+(?![\w\s?&./;#~%"=-]*>))/g
      return text.replaceAll(linkRegex, '<a href="$1" target="_blank" rel="nofollow">$1</a>')
    }
  }
}
</script>
<style scoped lang="scss" src="./notification-comp-styles/notification-details.scss"></style>
